@if (isPopupNeeded$ | async) {
  <section class="flex-lg-row">
    <span [innerHTML]="'COOKIES_POPUP_TEXT' | translate"></span>
    <div>
      <button (click)="accept()" class="button button--filled button--shadow">
        {{ 'ACCEPT' | translate }}
      </button>
      <button (click)="decline()" class="button button--outlined">
        {{ 'DECLINE' | translate }}
      </button>
      <a [routerLink]="[cookieSettingsPath]" class="button button--outlined">{{
        'CONFIGURE' | translate
      }}</a>
    </div>
  </section>
}
